// extracted by mini-css-extract-plugin
export default {"pubImage":"Publications_pubImage__jgR7T"};